/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opening_The_VaultInputs */

const en_opening_the_vault = /** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening the vault...`)
};

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const es_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const fr_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const de_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const ja_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const zh_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const ar_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const id_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const it_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const ru_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const pt_opening_the_vault = en_opening_the_vault;

/** @type {(inputs: Opening_The_VaultInputs) => LocalizedString} */
const ko_opening_the_vault = en_opening_the_vault;

/**
* | output |
* | --- |
* | "Opening the vault..." |
*
* @param {Opening_The_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const opening_the_vault = /** @type {((inputs?: Opening_The_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opening_The_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opening_the_vault(inputs)
	if (locale === "es") return es_opening_the_vault(inputs)
	if (locale === "fr") return fr_opening_the_vault(inputs)
	if (locale === "de") return de_opening_the_vault(inputs)
	if (locale === "ja") return ja_opening_the_vault(inputs)
	if (locale === "zh") return zh_opening_the_vault(inputs)
	if (locale === "ar") return ar_opening_the_vault(inputs)
	if (locale === "id") return id_opening_the_vault(inputs)
	if (locale === "it") return it_opening_the_vault(inputs)
	if (locale === "ru") return ru_opening_the_vault(inputs)
	if (locale === "pt") return pt_opening_the_vault(inputs)
	return ko_opening_the_vault(inputs)
});